import styles from './LoadingPage.module.css';

export const LoadingPage = () => {
  return (
    <div className={styles.loadingPage}>
      <div className={styles.spinLoader} />
      <div className={styles.fadeInUp}>
        <h1 className={styles.header}>Synergi Life AI</h1>
        <p className={styles.message}>Please wait a moment</p>
      </div>
    </div>
  );
};
